<template>
  <router-view />
  <ReadingTimer />
</template>

<script>
import ReadingTimer from '@/components/ReadingTimer.vue'

export default {
  name: 'App',
  components: {
    ReadingTimer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
